export default __webpack_public_path__ + "static/media/pokedex-detail-list.00148987.png";